import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css, cx } from "@emotion/css";
import { useBlockComponentContext } from "../../form-blocks";
import { Box } from "../../box";
import { Icon } from "../../icon";
import { Text } from "../../text";
import { theme } from "../../theme";
export const GroupRow = ({ data, expanded, onClick }) => {
    const { Translated } = useBlockComponentContext();
    return (_jsx("div", { onClick: () => onClick(data.id), id: `toggle-block-${data.id}-button`, children: _jsxs(Box, { flexDirection: "row", alignItems: "center", justifyContent: "space-between", className: cx("grouprow-0-43", cls.container), children: [_jsxs(Box, { flexDirection: "row", alignItems: "center", children: [_jsx("div", { className: cx(cls.dropdownBtn, {
                                up: expanded,
                            }), children: _jsx(Icon, { name: "sort-down", size: 14 }) }), _jsx(Text, { className: cls.title, fontSize: "1.25em", lineHeight: "1.5em", children: _jsx(Translated, { translationKey: data.title.translationKey }) })] }), _jsx(Status, { totalSlides: data.totalSlides, completedSlides: data.completedSlides, flaggedSlides: data.flaggedSlides })] }) }));
};
const Status = ({ flaggedSlides, completedSlides, totalSlides }) => {
    if (flaggedSlides > 0) {
        return (_jsx(Text, { color: "deepOrange100", fontSize: "1.25em", children: "Help requested" }));
    }
    else {
        return (totalSlides - completedSlides === 0 && (_jsx(Text, { color: "green100", fontSize: "1.25em", children: "Done" })));
    }
};
const cls = {
    container: css `
    cursor: pointer;

    &:hover * {
      transform: translateY(-1px);
      opacity: 0.7;
    }
  `,
    dropdownBtn: css `
    position: relative;

    display: grid;
    place-items: center;

    border: 1px solid;
    border-color: ${theme.color.primary};
    border-radius: 50%;

    min-width: 1.75em;
    min-height: 1.75em;
    width: 1.75em;
    height: 1.75em;

    color: ${theme.color.primary};

    box-shadow: 0 2px 10px 0 rgba(117, 121, 128, 0.2);

    & > i {
      margin-top: 0.25em;
      font-size: 0.875em;
    }

    &.up {
      border-color: ${theme.color.primary};
      background-color: ${theme.color.primary};
    }

    &.up > i {
      top: 5px;
      left: 5px;
      color: #fff;
      transform: rotate(-90deg);
    }
  `,
    title: css `
    font-weight: 600;
    margin-left: 15px;
    margin-top: 2px;
  `,
};
